import { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { useForm, useFieldArray, Controller } from 'react-hook-form'
import { DefaultConfig } from '../../settings/config'
import { useParams, useNavigate } from 'react-router-dom'
import * as yup from "yup"
import { GetUserByEmail, GetVesselDetailsById, UpdateVessel, UpdateVesselUserMapping, CreateUserVesselMapping } from '../redux/store'
import classnames from 'classnames'
import { yupResolver } from "@hookform/resolvers/yup"
import { isObjEmpty, selectThemeColors } from '@utils'
import Select from 'react-select'
import { Row, Col, Button, Label, Input, Form, FormFeedback, Spinner, Modal, ModalHeader, ModalBody, ModalFooter, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Table } from 'reactstrap'
import { Edit, Plus, Trash2, RefreshCcw, ChevronUp, ChevronDown } from "react-feather"
import CustomValueContainer from "../Components/Select"
import ComponentSpinner from '../../components/spinner/Loading-spinner'
import Sidebar from '../Components/SideBar'
import toast from 'react-hot-toast'
import ToastMessage from '../../components/toast-messages'
import { isUserLoggedIn } from "../../@core/auth/utils"
import { color } from 'framer-motion'

const ActiveVesel = () => {

  const vesselRoles = [
    { id: 1, label: "Default", value: "DPA", isActive: true },
    { id: 2, label: "Role1", value: "RO1", isActive: true },
    { id: 3, label: "Role2", value: "RO2", isActive: true }
  ]

  const loggedinUserDetails = isUserLoggedIn() && JSON.parse(isUserLoggedIn())
  const dispatch = useDispatch()
  const stores = useSelector((state) => state.commonreducerSlice)
  const selectStyles = DefaultConfig().selectStyles
  const vesselWriterRole = DefaultConfig().VesselWriterRole
  const formattedDateIssueFixed = DefaultConfig().formattedDateIssueFixed
  const { id } = useParams()

  const [mspinnerStatus, setMSpinnerStatus] = useState(false)
  const [spinnerStatus, setSpinnerStatus] = useState(false)
  const [spinnerUStatus, setUSpinnerStatus] = useState(true)

  const [addressStatus, setAddressStatus] = useState(true)
  const [sortConfig, setSortConfig] = useState({ key: 'userFirstName', direction: 'asc' })
  const [companyIdData, setCompanyIdData] = useState(null)
  const [statusOption, setStatus] = useState(null)
  const [filterFirstName, setFilterFirstName] = useState('')
  const [filterLastName, setFilterLastName] = useState('')
  const [filterEmail, setFilterEmail] = useState('')
  const [loadingUserId, setLoadingUserId] = useState(null)
  const [vesselId, setVesselId] = useState()
  const [imonumber, setImoNumber] = useState()
  const [officialNumber, setOfficialNumber] = useState()
  const [show, setShow] = useState(false)
  const [disableSpinner, setDisableSpinner] = useState(false)
  const [disabling, setDisabling] = useState(false)

  const statusOptions = [
    { value: 'All', label: 'All', id: 3 },
    { value: 'Active', label: 'Active', id: 1 },
    { value: 'InActive', label: 'InActive', id: 2 }

  ]
  const [userStatus, setUserStatus] = useState(statusOptions[0])
  const [vname, setName] = useState("")
  const options = [
    { value: 'Active', label: 'Active', id: 1 },
    { value: 'InActive', label: 'InActive', id: 2 },
    { value: 'Suspended', label: 'Suspended', id: 3 }
  ]

  const [newFirstName, setNewFirstName] = useState("")
  const [newLastName, setNewLastName] = useState("")
  const [newEmail, setNewEmail] = useState("")
  const [modalSpinnerStatus, setMOdalSpinnerStatus] = useState(false)
  const [selectedVesselRole, setSelectedVesselRole] = useState(null)
  const [vesselUserId, setUserId] = useState()

  const ValidSchema = yup.object().shape({
    [`newFirstName`]: yup.string().nullable().required("First Name is a required field"),
    [`newLastName`]: yup.string().nullable().required("Last Name is a required field"),
    [`newEmail`]: yup.string().trim().nullable().required("Email is a required field").email("Email is invalid"),
    [`vesselRole`]: yup.object().nullable().required("Vessel Role is a required field")
  })

  const { trigger, handleSubmit, control, reset, setValue, formState: { errors } } = useForm({ mode: 'onChange', resolver: yupResolver(ValidSchema) })

  const handleReset = () => {
    reset({
      newFirstName: null,
      newLastName: null,
      newEmail: null,
      sourceSystem: null
    })
    setNewEmail("")
    setValue("newEmail", "")
    setNewFirstName("")
    setValue("newFirstName", "")
    setValue("newLastName", "")
    setNewLastName("")
    // setSourceSystem(null)
    // setValue("sourceSystem", null)
    setDisabling(false)
  }

  const filteredUsers = companyIdData?.vesselUsers?.filter(company => {
    return (
      (!filterFirstName || company.userFirstName.toLowerCase().includes(filterFirstName.toLowerCase())) &&
      (!filterLastName || company.userLastName.toLowerCase().includes(filterLastName.toLowerCase())) &&
      (!filterEmail || company.userEmail.toLowerCase().includes(filterEmail.toLowerCase()))
      // (!filterSourceSystemId || company.sourceSystemId === filterSourceSystemId?.id)
    )
  }) ?? []

  const sortedUsers = [...filteredUsers].sort((a, b) => {
    const aValue = a[sortConfig.key] ?? ''
    const bValue = b[sortConfig.key] ?? ''

    if (typeof aValue === 'string' && typeof bValue === 'string') {
      return sortConfig.direction === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue)
    }

    // For numbers or other types, direct comparison
    if (aValue < bValue) {
      return sortConfig.direction === 'asc' ? -1 : 1
    }
    if (aValue > bValue) {
      return sortConfig.direction === 'asc' ? 1 : -1
    }
    return 0
  })

  const requestSort = (key) => {
    let direction = 'asc'
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc'
    }
    setSortConfig({ key, direction })
  }

  const getNdaData = (data) => {
    const companyIdData = { ...data }
    if (companyIdData) {

      setCompanyIdData(companyIdData)
      if (companyIdData?.status) {
        const temp = options.find((item) => item.id === companyIdData?.status)
        setStatus(temp)
      }
      // setAddressOption(optionAdrress[0])
      setName(companyIdData.name ? companyIdData.name : vname)
      setValue('vesselName', companyIdData.vname ? companyIdData.name : '')

      setVesselId(companyIdData.vesselId ? companyIdData.vesselId : vesselId)
      setValue('vesselId', companyIdData.vesselId ? companyIdData.vesselId : '')

      setImoNumber(companyIdData.imonumber ? companyIdData.imonumber : imonumber)
      setValue('imonumber', companyIdData.imonumber ? companyIdData.imonumber : '')

      setOfficialNumber(companyIdData.officialNumber ? companyIdData.officialNumber : officialNumber)
      setValue('officialNumber', companyIdData.officialNumber ? companyIdData.officialNumber : '')

    }
  }

  async function fetch(value1, value2) {
    const obj = {}
    obj.id = Number(id)
    obj.isAddressMapping = value2
    if (value1 !== 3) {
      obj.isUserMapping = value1 === 1 ? true : value1 === 2 ? false : ""
    }
    setSpinnerStatus(false)
    const response = await dispatch(GetVesselDetailsById(obj)).finally(() => { })
    if (response.payload) {
      if (true) {
        // MappingFunction(response.payload.data)
        getNdaData(response.payload.data)
      }
    } else {
      setSpinnerStatus(false)
    }
  }

  useEffect(() => {
    fetch(userStatus?.id, addressStatus)
  }, [Number(id)])

  const [isEdited, setIsEdited] = useState(false)

  async function userUpdateFunction() {
    setUSpinnerStatus(false)
    const obj = {}
    obj["id"] = Number(id)
    obj["name"] = vname
    obj["vesselId"] = vesselId
    if (imonumber) {
      obj["imonumber"] = imonumber
    }
    if (officialNumber) {
      obj["officialNumber"] = officialNumber
    }
    if (statusOption.id) {
      obj["status"] = statusOption.id
    }
    // if (companyIdData.officialNumber) {
    //   obj["officialNumber"] = companyIdData.officialNumber
    // }

    const response = await dispatch(UpdateVessel(obj)).finally(() => {
      setUSpinnerStatus(true)
      setMOdalSpinnerStatus(false)
      setIsEdited(false)
    })
    if (response.payload) {
      fetch(userStatus.id, addressStatus)
    }
  }

  const MakeInActive = async (value1, value2, vesselRoleId) => {
    setLoadingUserId(value1)
    const obj = {}
    obj.vesselId = Number(id)
    obj.userId = value1
    obj.isActive = !value2
    obj.vesselRoleId = vesselRoleId
    // obj.email = passedEmail
    obj.lastModifiedBy = loggedinUserDetails?.userRoles[0]?.userId
    console.log(obj, "obj")
    const response = await dispatch(UpdateVesselUserMapping(obj)).finally(() => {
      setLoadingUserId(null)
      setMOdalSpinnerStatus(false)
    })
    if (response.payload) {
      fetch(userStatus?.id, addressStatus)
    }
  }

  function cancel() {
    const temp = options.find((item) => item?.id === companyIdData?.status)
    setStatus(temp)
  }
  const toggleSidebar = () => {
    // handleReset()
    setShow(false)
  }

  const onSubmit = async () => {
    trigger()
    if (Object.keys(errors).length === 0) {
      const obj = {}
      obj.userId = vesselUserId
      obj.vesselId = id
      obj.userIds = [{ userEmail: newEmail, firstName: newFirstName, lastName: newLastName }]
      obj.vesselRoleId = selectedVesselRole?.id
      console.log(obj, "obj")
      async function fetch1() {
        setMSpinnerStatus(true)
        const response = await dispatch(CreateUserVesselMapping(obj)).finally(() => {
          setMSpinnerStatus(false)
        })
        if (response.payload) {
          fetch(userStatus.id, addressStatus)
          setShow(false)
          reset()
        }
      }
      fetch1()
    }
  }

  const [modalOpen, setModalOpen] = useState(false)
  const [currentAction, setCurrentAction] = useState(null)
  const [selectedUser, setSelectedUser] = useState(null)

  const toggleModal = () => setModalOpen(!modalOpen)

  const handleActionClick = (userId, actionType, vesselRoleId) => {
    setSelectedUser({ userId, vesselRoleId })
    setCurrentAction(actionType)
    toggleModal()
  }

  const handleConfirm = () => {
    setMOdalSpinnerStatus(true)
    if (currentAction === true) {
      MakeInActive(selectedUser.userId, true, selectedUser.vesselRoleId)
    } else if (currentAction === false) {
      MakeInActive(selectedUser.userId, false, selectedUser.vesselRoleId)
    }
    toggleModal() // Close modal after confirming
  }

  return (
    !spinnerStatus ? (<div>

      <Row className="card_style pt-2 pb-2" style={{ margin: "0px 0px" }}>
        <Sidebar
          size="sm"
          open={show}
          title={`Add User Details`}
          headerClassName="mb-1"
          contentClassName="pt-0"
          toggleSidebar={toggleSidebar}

        >
          {(show) ? (<>
            <Form onSubmit={handleSubmit(onSubmit)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault()
                }
              }}
              style={{ margin: '0 0' }}>
              <ModalBody style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '20px' }}>
                <Row>
                  <Col sm='12' md='12' lg='12' xl='12'>
                    <div className='mt-2 input-wrapper'>
                      <Controller
                        defaultValue=''
                        control={control}
                        id='newEmail'
                        name='newEmail'
                        render={({ field: { onChange, onBlur } }) => <Input
                          placeholder=''
                          invalid={errors.newEmail && true}
                          value={newEmail}
                          onChange={(val) => {
                            if (val.target.value) {
                              delete errors.newFirstName
                              delete errors.newLastName
                              // delete errors.sourceSystem
                            }
                            if (val.target.value === "") {

                              setValue("newFirstName", "")
                              setValue("newLastName", "")
                              setNewLastName("")
                              setNewFirstName("")
                              setDisabling(false)
                            }
                            onChange(val, setNewEmail(val.target.value))
                          }}
                          onBlur={async () => {
                            onBlur()
                            if (!errors.newEmail && newEmail) {
                              try {
                                setDisableSpinner(true)
                                const response = await dispatch(GetUserByEmail({ email: newEmail }))
                                if (response?.payload) {
                                  setDisabling(true)
                                  setDisableSpinner(false)
                                  setValue("newFirstName", response?.payload?.data.firstName)
                                  setNewFirstName(response?.payload?.data.firstName)
                                  setValue("newLastName", response?.payload?.data.lastName)
                                  setNewLastName(response?.payload?.data.lastName)
                                  setValue("userId", response?.payload?.data.id)
                                  setUserId(response?.payload?.data.id)
                                  delete errors.newFirstName
                                  delete errors.newLastName
                                  // delete errors.sourceSystem
                                  toast(t => (<ToastMessage t={t} message={" User Data Found"} status={"success"} />))
                                } else {
                                  setDisableSpinner(false)
                                  setDisabling(false)
                                  setValue("newFirstName", "")
                                  setNewFirstName("")
                                  setValue("newLastName", "")
                                  setNewLastName("")
                                  delete errors.newFirstName
                                  delete errors.newLastName
                                  // delete errors.vesselRole
                                  toast(t => (<ToastMessage t={t} message={"User Data not Found"} status={"success"} />))
                                }

                              } catch (error) {
                                console.error('API call failed:', error)
                              }
                            }
                          }}
                        />}
                      />
                      <Label className='form-label' for={`newEmail`}>
                        Email
                      </Label>
                      {errors.newEmail && <FormFeedback>{errors.newEmail.message}</FormFeedback>}
                    </div>
                  </Col>
                </Row>
                {
                  !disableSpinner ? <> {disabling && <Row>
                    <Col sm='12' md='12' lg='12' xl='12'>
                      <div className='mt-2 input-wrapper'>
                        <Controller
                          defaultValue=''
                          control={control}
                          id='newFirstName'
                          name='newFirstName'
                          render={({ field: { onChange } }) => <Input
                            placeholder=''
                            invalid={errors.newFirstName && true}
                            value={newFirstName}
                            disabled={!disabling}
                            onChange={(val) => {
                              onChange(val, setNewFirstName(val.target.value))
                            }}
                          />}
                        />
                        <Label className='form-label' for={`newFirstName`}>
                          First Name
                        </Label>
                        {errors.newFirstName && <FormFeedback>{errors.newFirstName.message}</FormFeedback>}
                      </div>
                    </Col>
                  </Row>}
                    {disabling && <Row>
                      <Col sm='12' md='12' lg='12' xl='12'>
                        <div className='mt-2 input-wrapper'>
                          <Controller
                            defaultValue=''
                            control={control}
                            id='newLastName'
                            name='newLastName'

                            render={({ field: { onChange } }) => <Input
                              placeholder=''
                              invalid={errors.newLastName && true}
                              value={newLastName}
                              disabled={!disabling}
                              onChange={(val) => {
                                onChange(val, setNewLastName(val.target.value))
                              }}
                            />}
                          />
                          <Label className='form-label' for={`newLastName`}>
                            Last Name
                          </Label>
                          {errors.newLastName && <FormFeedback>{errors.newLastName.message}</FormFeedback>}
                        </div>
                      </Col>
                    </Row>}
                    {disabling && <Row>
                      <Col sm='12' md='12' lg='12' xl='12'>
                        <div className='mt-2 input-wrapper'>
                          <Controller
                            defaultValue=''
                            control={control}
                            id='vesselRole'
                            name='vesselRole'
                            render={({ field: { onChange } }) => <Select
                              classNamePrefix="select"
                              options={vesselRoles}
                              value={selectedVesselRole}
                              isClearable
                              isDisabled={!disabling}
                              onChange={(val) => {
                                onChange(val)
                                setSelectedVesselRole(val)
                                setValue("selectedVesselRole", val)
                                if (val) {
                                  delete errors.vesselRole
                                }
                              }}
                              // className={classnames('react-select', { 'is-invalid': errors['vesselRole'] })}
                              placeholder={`select Vessel Role`}
                              styles={selectStyles}
                              components={{ ValueContainer: CustomValueContainer }}
                            />}
                          />
                          {errors.vesselRole && <FormFeedback>{errors.vesselRole.message}</FormFeedback>}
                        </div>
                        <div>
                        </div>
                      </Col>
                    </Row>}
                  </> : <>
                    <ComponentSpinner></ComponentSpinner></>
                }

              </ModalBody>

              <ModalFooter className='p-0 d-block' style={{ border: 0, marginTop: '30px' }}>
                <Row>
                  <Col sm='12' md='12' lg='12' xl='12' className='p-0 mt-1'>
                    <div className='model_popup_panel model_popup_submit_btn model_popup_footer_fixed' style={{ justifyContent: 'center', padding: "12px 0px", display: "flex", background: "unset" }}>
                      {mspinnerStatus ? (
                        <Button.Ripple color='primary' disabled={mspinnerStatus}>
                          <Spinner size='sm' />
                          <span className='mx-50'>Loading...</span>
                        </Button.Ripple>
                      ) : (
                        <Fragment>
                          <Button className='me-1 reset_button_view' outline color='secondary' onClick={handleReset}>
                            <RefreshCcw size={14} className='align-middle me-sm-25 me-0' />
                            <span className='align-middle d-sm-inline-block mx-50'>Reset</span>
                          </Button>
                          <Button className='create_submit_btn' type='submit' disabled={!disabling}>
                            <span className='align-middle d-sm-inline-block mx-50'>{'Mapping User'}</span>
                          </Button>
                        </Fragment>
                      )}
                    </div>
                  </Col>
                </Row>
              </ModalFooter>
            </Form></>) : (
            <ComponentSpinner />
          )}
        </Sidebar>

        <Col sm='12' md='12' lg='12' xl='12'>
          <span className='headers-style mt-1'>Vessel Information <span style={{ marginLeft: "-5px" }}>
            {/* {!userDetailsDisabling && 
            <span className='headers-style mt-3 mx-2' style={{ cursor: "pointer" }} onClick={() => {
              setUserDetailsDisabling(!userDetailsDisabling)
            }}>
              <Edit size={18}></Edit></span>
            } */}
          </span></span>
        </Col>

        {vname ? (<>
          <Col sm='12' md='12' lg='4' xl='4'>
            <div className='input-wrapper mt-2'>
              <Controller
                control={control}
                id='vname'
                name='vname'
                render={({ field: { onChange } }) => <Input
                  placeholder=''
                  invalid={errors.vname && true}
                  value={vname}
                  disabled={true}
                  onChange={(val) => {
                    onChange(val, setName(val.target.value))
                  }} />}
              />
              <Label className='form-label input_label' for={`vname`}>
                vessel Name<span className='text-danger'>*</span>
              </Label>
              {errors.vname && <FormFeedback>{errors.vname.message}</FormFeedback>}
            </div>
          </Col>
          <Col sm='12' md='12' lg='4' xl='4'>
            <div className='input-wrapper mt-2'>
              <Controller

                control={control}
                id=''
                name='vesselId'
                render={({ field: { onChange } }) => <Input
                  placeholder=''
                  invalid={errors.vesselId && true}
                  value={vesselId}
                  disabled={true}
                  onChange={(val) => {
                    onChange(val, setVesselId(val.target.value))
                    if (val.target.value !== vesselId) {
                      setIsEdited(true)
                    }
                  }} />}
              />
              <Label className='form-label input_label' for={`vesselId`}>
                vessel ID <span className='text-danger'>*</span>
              </Label>
              {errors.companyAgentId && <FormFeedback>{errors.vesselId.message}</FormFeedback>}
            </div>
          </Col>
          {imonumber && <Col sm='12' md='12' lg='4' xl='4'>
            <div className='input-wrapper mt-2'>
              <Controller
                control={control}
                id='imonumber'
                name='imonumber'
                render={({ field: { onChange } }) => <Input
                  placeholder=''
                  invalid={errors.imonumber && true}
                  value={imonumber}
                  disabled={true}
                  onChange={(val) => { onChange(val, setImoNumber(val.target.value)) }} />}
              />
              <Label className='form-label input_label' for={`imonumber`}>
                imoNumber <span className='text-danger'>*</span>
              </Label>
            </div>
          </Col>}
          <Col sm='12' md='12' lg='4' xl='4'>
            <div className='input-wrapper mt-2'>
              <Controller
                control={control}
                id='officialNumber'
                name='department'
                render={({ field: { onChange } }) => <Input
                  placeholder=''
                  invalid={errors.officialNumber && true}
                  value={officialNumber}
                  disabled={true}

                  onChange={(val) => {
                    onChange(val, setOfficialNumber(val.target.value))
                    // if (val.target.value !== officialNumber) {
                    //   setIsEdited(true)
                    // }
                  }} />}
              />
              <Label className='form-label input_label' for={`department`}>
                officialNumber<span className='text-danger'>*</span>
              </Label>
              {errors.officialNumber && <FormFeedback>{errors.officialNumber.message}</FormFeedback>}
            </div>
          </Col>
          {vesselWriterRole() && (
            <Col sm='12' md='12' lg='4' xl='4' className="mt-2">
              <div>
                <Select
                  classNamePrefix="select"
                  options={options}
                  value={statusOption}
                  onChange={(val) => {
                    setStatus(val)
                  }}
                  className={classnames('react-select', { 'is-invalid': errors['country'] })}
                  placeholder={`Select Status`}
                  styles={selectStyles}
                  components={{ ValueContainer: CustomValueContainer }}
                />
              </div>
            </Col>
          )}
          {/* <Col sm='12' md='12' lg='4' xl='4' className="mt-2">
            {<Select
              classNamePrefix="select"
              options={regionalOffices}
              value={regionalOption}
              onChange={(val) => {
                setRegionalOption(val)
              }}
              isClearable
              className={classnames('react-select')}
              placeholder={`Regional Office`}
              styles={selectStyles}
              components={{ ValueContainer: CustomValueContainer }}
            />}
          </Col> */}
          <Col>

            {((companyIdData?.status !== statusOption?.id)) && <div className='model_popup_panel model_popup_submit_btn' style={{ padding: "27px 0px 0px" }}>
              <Button color='secondary' onClick={() => cancel()} className='me-1 reset_button_view btn-cancel' > Cancel </Button>
              {
                spinnerUStatus ? (
                  <Button color='secondary' onClick={() => userUpdateFunction()} className='create_submit_btn' >Update</Button>
                ) : (
                  <Button className='me-1' color='secondary' disabled={!spinnerUStatus}>
                    <Spinner size='sm' />
                    <span className='mx-50'>Loading...</span>
                  </Button>
                )}
            </div>}
          </Col>
        </>
        ) : (<div className='text-center'>
          No records to Display</div>)}

      </Row>

      {
        <Row className="card_style pt-2 pb-2 mt-2" style={{ margin: "0px 0px", minHeight: "260px" }}>

          {<div className='sub_header-style' style={{ fontWeight: 500 }}>Vessel Associated Users List</div>}
          {vesselWriterRole() && (
            <Col sm='12' md='6' lg='4' xl='4' className="mt-1">
              {<Button
                className='btn-next me-1 next_btn_panel'
                color='primary'
                style={{ padding: "0.7rem", marginTop: "5px" }}
                size='sm'
                onClick={() => {
                  setShow(true)
                }}
              >
                <Plus size={18} />
                <span className='align-middle ms-25'>Add New</span>
              </Button>}
            </Col>)}

          <Row className="mt-1 mb-1">
            <Col sm="12" className="mt-1">
              <div style={{ fontSize: "16px", color: "#000", fontWeight: 500 }}>Filter By:</div>
            </Col>

            {/* First Name Filter */}
            <Col sm='6' md='6' lg='3' xl='3' className="form_input_wrapper_bootstrapping">
              <div className='input-wrapper mt-2'>
                <Input
                  type="text"
                  placeholder=""
                  value={filterFirstName}
                  onChange={(e) => setFilterFirstName(e.target.value)}
                />
                <Label className='form-label input_label' for='first-name'>
                  First Name
                </Label>
              </div>
            </Col>

            {/* Last Name Filter */}
            <Col sm='6' md='6' lg='3' xl='3' className="form_input_wrapper_bootstrapping">
              <div className='input-wrapper mt-2'>
                <Input
                  type="text"
                  placeholder=""
                  value={filterLastName}
                  onChange={(e) => setFilterLastName(e.target.value)}
                />
                <Label className='form-label input_label' for='last-name'>
                  Last Name
                </Label>
              </div>
            </Col>

            {/* Email Filter */}
            <Col sm='6' md='6' lg='3' xl='3' className="form_input_wrapper_bootstrapping">
              <div className='input-wrapper mt-2'>
                <Input
                  type="text"
                  placeholder=""
                  value={filterEmail}
                  onChange={(e) => setFilterEmail(e.target.value)}
                />
                <Label className='form-label input_label' for='email'>
                  Email
                </Label>
              </div>
            </Col>

            {/* Source System Filter */}
            {/* <Col sm='6' md='6' lg='3' xl='3' className="mt-2">
              <Select
                classNamePrefix="select"
                options={SourceSystem("options")}
                isClearable
                value={filterSourceSystemId}
                onChange={(val) => setFilterSourceSystemId(val)}
                className={classnames('react-select', { 'is-invalid': false })}
                placeholder="Source System"
              
              />
            </Col> */}

            {/* Status Filter */}
            <Col sm='6' md='6' lg='3' xl='3' className="mt-2">
              <div>
                <Select
                  classNamePrefix="select"
                  options={statusOptions}
                  value={userStatus}
                  onChange={(val) => {
                    setUserStatus(val)
                    if (val) {
                      fetch(val?.id, addressStatus)
                    }
                  }}
                  className={classnames('react-select', { 'is-invalid': errors['country'] })}
                  placeholder={`Select Status`}
                  styles={selectStyles}
                  components={{ ValueContainer: CustomValueContainer }}
                />
              </div>
            </Col>

            {/* Reset Button */}
            <Col sm='6' md='6' lg='9' xl='9' className="mt-2">
              <div className='model_popup_panel model_popup_submit_btn model_popup_footer_fixed' style={{ padding: "12px 0px", display: "flex", background: "unset" }}>
                {(filterFirstName || filterLastName || filterEmail) && (
                  <Button className='me-1 reset_button_view' outline color='secondary' style={{ paddding: "0px 0px" }} onClick={() => {
                    setFilterEmail("")
                    setFilterFirstName("")
                    setFilterLastName("")
                    // setFilterSourceSystemId(null)
                  }}>
                    <RefreshCcw size={14} className='align-middle me-sm-25 me-0' />
                    <span className='align-middle d-sm-inline-block mx-50'>Reset</span>
                  </Button>
                )}
              </div>
            </Col>
          </Row>

          <div className='d-flex' style={{ justifyContent: "space-between" }}>

            <Table striped bordered hover>
              <thead>
                <tr>
                  <th onClick={() => requestSort('userFirstName')} className="sortable-header">
                    First Name
                    <span className="chevron-icon">
                      {(sortConfig.direction === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />)}
                    </span>
                  </th>
                  <th onClick={() => requestSort('userLastName')} className="sortable-header">
                    Last Name
                    <span className="chevron-icon">
                      {(sortConfig.direction === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />)}
                    </span>
                  </th>
                  <th onClick={() => requestSort('userEmail')} className="sortable-header">
                    Email
                    <span className="chevron-icon">
                      {(sortConfig.direction === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />)}
                    </span>
                  </th>
                  <th onClick={() => requestSort('lastModifiedDate')} className="sortable-header">
                    Last Modified Date
                    <span className="chevron-icon">
                      {(sortConfig.direction === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />)}
                    </span>
                  </th>
                  <th onClick={() => requestSort('vesselRoleId')} className="sortable-header">
                    vessel Role Id
                    <span className="chevron-icon">
                      {(sortConfig.direction === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />)}
                    </span>
                  </th>
                  {/* {filteredUsers?.find((item) => item.isUserMapping === false) && */}
                  <th>Status</th>
                  {/* } */}
                  {vesselWriterRole() && (<th>Action</th>)}
                </tr>
              </thead>
              {sortedUsers.length ? (
                <tbody>
                  {sortedUsers.map((company) => (
                    < tr key={company.id} >
                      <td>{company.userFirstName}</td>
                      <td>{company.userLastName}</td>
                      <td>{company.userEmail}</td>
                      <td>{formattedDateIssueFixed(company.lastModifiedDate)}</td>
                      <td>{vesselRoles.find((role) => role.id === company.vesselRoleId)?.value}</td>

                      {
                        // filteredUsers.find((item) => item.isUserMapping === false) && (
                        <td>{company.isUserMapping ? "Active" : "Inactive"}</td>
                        // )
                      }
                      {vesselWriterRole() && (
                        <td>
                          {
                            company.isUserMapping ? (
                              <div className="d-flex" style={{ justifyContent: "space-between" }}>
                                <div className='headers-style removeAddress' style={{ width: "100%", background: "none", boxShadow: "none", fontWeight: 400, fontSize: "14px", padding: "0px", textAlign: "left" }} onClick={() => handleActionClick(company.userId, true, company.vesselRoleId)}>
                                  {loadingUserId === company.userId ? (
                                    <div>
                                      <Spinner size='sm' />
                                      <span className='mx-50'>Loading...</span>
                                    </div>
                                  ) : (
                                    <div>
                                      <Trash2 size={18} /><span className='mx-1'>Remove</span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ) : (<div>
                              <div className="d-flex" style={{ justifyContent: "space-between" }}>
                                <div className='headers-style removeAddress' style={{ width: "100%", background: "none", boxShadow: "none", fontWeight: 400, fontSize: "14px", padding: "0px", textAlign: "left", color: "#00adc3" }} onClick={() => handleActionClick(company.userId, false, company.vesselRoleId)}>
                                  {loadingUserId === company.userId ? (
                                    <div>
                                      <Spinner size='sm' />
                                      <span className='mx-50'>Loading...</span>
                                    </div>
                                  ) : (
                                    <div>
                                      <Plus size={18} /><span className='mx-1'>Make Active</span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>)
                          }
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>) : (
                <tbody >
                  <td colSpan={5} style={{ textAlign: "center", fontSize: "14px", color: '#000' }}>
                    No Records to Display
                  </td>
                </tbody>
              )}
            </Table>

            <Modal isOpen={modalOpen} toggle={toggleModal} color='primary' className='modal-dialog-centered'>
              <ModalHeader toggle={toggleModal}>
                {currentAction === true ? "Confirm Removal" : "Confirm User Mapping"}
              </ModalHeader>
              <ModalBody className='p-2'>
                {currentAction === true ? "Are you sure you want to remove this user?" : "Are you sure you want to map this user"}
              </ModalBody>
              <ModalFooter className='p-0 d-block' style={{ border: 0, marginTop: '30px' }}>
                <div className='model_popup_panel model_popup_submit_btn' style={{ justifyContent: 'center' }}>
                  <Button onClick={() => cancel()} className='me-1 reset_button_view btn-cancel'> Cancel </Button>
                  <Button
                    color={currentAction === true ? "primary" : "primary"}
                    onClick={handleConfirm}
                    disabled={modalSpinnerStatus}
                  >
                    {modalSpinnerStatus ? (
                      <>
                        <Spinner size='sm' />
                        <span className='mx-50'>Loading...</span>
                      </>
                    ) : (
                      currentAction === true ? "Remove User" : "Mapping User"
                    )}
                  </Button>
                </div>
              </ModalFooter>
            </Modal>

          </div>
        </Row>
      }
    </div >) : (
      <ComponentSpinner></ComponentSpinner>
    )
  )
}
export default ActiveVesel